// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"comparepeoratesLayouts_mainWrapper__rWbNO"};